import { Navigate, Route, Routes } from 'react-router-dom'
import BidPage from 'views/pages/Bid/BidPage'
import BidRoutes from 'views/pages/Bid/routes'
import CallsPage from 'views/pages/Calls/CallsPage'
import CallsRoutes from 'views/pages/Calls/routes'
import CallStatisticsPage from 'views/pages/CallStatistics/CallStatisticsPage'
import CallStatisticsRoutes from 'views/pages/CallStatistics/routes'
import CompanyPage from 'views/pages/Company/CompanyPage'
import CompanyRoutes from 'views/pages/Company/routes'
import DashboardRoutes from 'views/pages/Dashboard/routes'
import DealPage from 'views/pages/Deal/DealPage'
import DealRoutes from 'views/pages/Deal/routes'
import SpecificationsRoutes from 'views/pages/Specifications/routes'
import SpecificationsPage from 'views/pages/Specifications/SpecificationsPage'
import TeamsPage from 'views/pages/Teams/TeamsPage'
import UsersRoutes from 'views/pages/User/routes'
import UserPage from 'views/pages/User/UserPage'

import CommonRoutes from 'views/pages/commonRoutes'
import { ContractsPage } from 'views/pages/Contracts/ContractsPage'
import { ContractsRoutes } from 'views/pages/Contracts/routes'
import DashboardPage from 'views/pages/Dashboard/DashboardPage'
import DispatchingPage from 'views/pages/Dispatching/DispatchingPage'
import DispatchingRoutes from 'views/pages/Dispatching/routes'
import { DocumentRequestsPage } from 'views/pages/DocumentRequests/DocumentRequestsPage'
import { DocumentRequestsRoutes } from 'views/pages/DocumentRequests/routes'
import { ExportPage } from 'views/pages/Export/ExportPage'
import ExportRoutes from 'views/pages/Export/routes'
import CarriersKRPage from 'views/pages/LogisticsKR/CarriersKR/CarriersKRPage'
import CarriersKRRoutes from 'views/pages/LogisticsKR/CarriersKR/routes'
import CarsKRPage from 'views/pages/LogisticsKR/CarsKR/CarsKRPage'
import CarsKRRoutes from 'views/pages/LogisticsKR/CarsKR/routes'
import CustomersKRPage from 'views/pages/LogisticsKR/CustomersKR/CustomersKRPage'
import CustomersKRRoutes from 'views/pages/LogisticsKR/CustomersKR/routes'
import LogisticRequestsPage from 'views/pages/LogisticsKR/LogisticRequests/LogisticRequestsPage'
import DealsKRRoutes from 'views/pages/LogisticsKR/LogisticRequests/routes'
import PaymentOrdersPage from 'views/pages/LogisticsKR/PaymentOrders/PaymentOrdersPage'
import PaymentOrdersRoutes from 'views/pages/LogisticsKR/PaymentOrders/routes'
import RatesPage from 'views/pages/LogisticsKR/Rates/RatesPage'
import RatesRoutes from 'views/pages/LogisticsKR/Rates/routes'
import WarehousesKRRoutes from 'views/pages/LogisticsKR/WarehousesKR/routes'
import WarehousesKRPage from 'views/pages/LogisticsKR/WarehousesKR/WarehousesKRPage'
import { MatchesPage } from 'views/pages/Matches/MatchesPage'
import MatchesRoutes from 'views/pages/Matches/routes'
import TasksRoutes from 'views/pages/MyTasks/routes'
import { TasksPage } from 'views/pages/MyTasks/TasksPage'
import { ReportsPage } from 'views/pages/Reports/ReportsPage'
import ReportsRoutes from 'views/pages/Reports/routes'
import SamplesRoutes from 'views/pages/Samples/routes'
import SamplesPage from 'views/pages/Samples/SamplesPage'
import { SdizRoutes } from 'views/pages/Sdiz/routes'
import SdizPage from 'views/pages/Sdiz/SdizPage'
import TeamsRoutes from 'views/pages/Teams/routes'
import UsContractsRoutes from 'views/pages/us/UsContracts/routes'
import UsContractsPage from 'views/pages/us/UsContracts/UsContractsPage'
import WarehousesRoutes from 'views/pages/Warehouses/routes'
import ElevatorRoutes from 'views/pages/Elevators/routes'
import WarehousesPage from 'views/pages/Warehouses/WarehousesPage'
import WhatsAppRoutes from 'views/pages/WhatsApp/routes'
import WhatsAppPage from 'views/pages/WhatsApp/WhatsAppPage'
import { defaultRoute } from './MainMenu/Options/CommonOptions'
import SellerPotentialPage from 'views/pages/SellerPotential/SellerPotentialPage'
import SellerPotentialRoutes from 'views/pages/SellerPotential/routes'
import { DocIndexRoutes } from 'views/pages/DocIndex/routes'
import DocIndexPage from 'views/pages/DocIndex/DocIndexPage'
import ElevatorPage from 'views/pages/Elevators/ElevatorPage'

export const CoordinatorsRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={defaultRoute} />} />
      <Route path="*" element={<Navigate to={CommonRoutes.NotFound} />} />
      <Route path={MatchesRoutes.relativePage} element={<MatchesPage />} />
      <Route path={DashboardRoutes.relativePage} element={<DashboardPage />} />
      <Route path={TeamsRoutes.relativePage} element={<TeamsPage />} />
      <Route path={CompanyRoutes.relativePage} element={<CompanyPage />} />
      <Route path={TasksRoutes.relativePage} element={<TasksPage />} />
      <Route path={ExportRoutes.relativePage} element={<ExportPage />} />
      <Route path={UsersRoutes.relativePage} element={<UserPage />} />
      <Route path={BidRoutes.relativePage} element={<BidPage />} />
      <Route path={DealRoutes.relativePage} element={<DealPage />} />
      <Route path={WarehousesRoutes.relativePage} element={<WarehousesPage />} />
      <Route path={ElevatorRoutes.relativePage} element={<ElevatorPage />} />
      <Route path={DispatchingRoutes.relativePage} element={<DispatchingPage />} />
      <Route path={CallsRoutes.relativePage} element={<CallsPage />} />
      <Route path={WhatsAppRoutes.relativePage} element={<WhatsAppPage />} />
      <Route path={CallStatisticsRoutes.relativePage} element={<CallStatisticsPage />} />
      <Route path={SpecificationsRoutes.relativePage} element={<SpecificationsPage />} />
      <Route path={DocumentRequestsRoutes.RelativePage} element={<DocumentRequestsPage />} />
      <Route path={ContractsRoutes.relativePage} element={<ContractsPage />} />
      <Route path={DealsKRRoutes.relativePage} element={<LogisticRequestsPage />} />
      <Route path={CarsKRRoutes.relativePage} element={<CarsKRPage />} />
      <Route path={CarriersKRRoutes.relativePage} element={<CarriersKRPage />} />
      <Route path={CustomersKRRoutes.relativePage} element={<CustomersKRPage />} />
      <Route path={WarehousesKRRoutes.relativePage} element={<WarehousesKRPage />} />
      <Route path={SamplesRoutes.relativePage} element={<SamplesPage />} />
      <Route path={RatesRoutes.relativePage} element={<RatesPage />} />
      <Route path={PaymentOrdersRoutes.relativePage} element={<PaymentOrdersPage />} />
      <Route path={SdizRoutes.relativePage} element={<SdizPage />} />
      <Route path={SellerPotentialRoutes.relativePage} element={<SellerPotentialPage />} />
      <Route path={ReportsRoutes.relativePage} element={<ReportsPage />} />
      <Route path={DocIndexRoutes.relativePage} element={<DocIndexPage />} />
      {/*TODO remove the old route for market zones */}
      <Route path={UsContractsRoutes.relativePage} element={<UsContractsPage />} />
    </Routes>
  )
}
